import { Notify } from 'quasar'

// Every chunk carries a content hash in its filename (leaflet-src-B6hpJip_.js),
// so a deploy renames all of them at once. A tab that was opened before the
// deploy still points at the old names, and the server answers those with
// index.html instead of a 404 — the browser refuses to run HTML as a module and
// the import rejects. Any lazy import can hit this, not just the route chunks
// the router already recovers from.
const staleChunkMessages = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Unable to preload CSS/i
]

export function isStaleChunkError(error) {
  const message = (error && error.message) || ''
  return staleChunkMessages.some(pattern => pattern.test(message))
}

// Navigation is already leaving the current page behind, so reloading straight
// into the target route costs the user nothing. The time guard keeps a chunk
// that is genuinely unreachable (offline) from spinning in a reload loop.
export function reloadForStaleChunk(fullPath) {
  const key = 'chunk-reload-at'
  const last = Number(window.sessionStorage.getItem(key) || 0)
  const now = new Date().getTime()
  if (now - last < 10000) return
  window.sessionStorage.setItem(key, String(now))
  window.location.assign(fullPath || window.location.href)
}

let promptOpen = false

// An import that fires from inside a page — opening a map, opening a dialog —
// can land while the user has unsaved work, so ask instead of reloading behind
// their back. Same prompt MainLayout shows when the API reports a newer
// interface_version; this one covers the tab that has not made that call since
// the deploy. Returns false when the failure is something else, so the caller
// can rethrow and let Sentry keep reporting it.
export function promptReloadForStaleChunk(error, t) {
  if (!isStaleChunkError(error)) return false
  if (promptOpen) return true

  promptOpen = true
  Notify.create({
    position: 'top',
    icon: 'fal fa-sync-alt',
    message: t('common.new-version'),
    type: 'negative',
    timeout: 0,
    actions: [
      {
        label: t('buttons.refresh'),
        color: 'white',
        handler: () => {
          window.location.reload()
        }
      },
      {
        label: t('buttons.dismiss'),
        color: 'white',
        handler: () => {
          promptOpen = false
        }
      }
    ]
  })
  return true
}
